import { Table, Button } from 'semantic-ui-react'
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import './style.css'

export default function Read() {
	
	const [APIData, setAPIData] = useState([]);
	
	useEffect(() => { 
		axios.get(`http://89.46.196.228:3000/api/tutorials`)
        .then((response) => {
        setAPIData(response.data);
		console.log(response.data);
        })
	}, [])
	
	const setData = (data) => {
    console.log(data);
	const { id, title, description, checkbox } = data;
    localStorage.setItem('ID', id);
    localStorage.setItem('First Name', title);
    localStorage.setItem('Last Name', description);
    localStorage.setItem('Checkbox Value', checkbox)
    }
	
	const getData = () => {
		axios.get(`http://89.46.196.228:3000/api/tutorials`)
        .then((response) => {
        setAPIData(response.data);
		console.log(response.data);
        })
}
	
	const onDelete = (id) => {
	axios.delete(`http://89.46.196.228:3000/api/tutorials/${id}`)
	 .then(() => {
        getData();
    })
    }

    return (
		<div className="main">
        <div>
            <Table singleLine>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Name</Table.HeaderCell>
                        <Table.HeaderCell>Registration Date</Table.HeaderCell>
                        <Table.HeaderCell>E-mail address</Table.HeaderCell>
                        <Table.HeaderCell>Premium Plan</Table.HeaderCell>
						<Table.HeaderCell>Update</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>

<Table.Body>
  {APIData.map((row) => {
	  const { id, photo, maticnibrojlovca, ime, prezime, adresa, telefon, lovackodrustvo, datumpolaganja, vrstaclanstva, lovackilist } = row; 
     return (
       <Table.Row key={row.id}>
          <Table.Cell>{row.title}</Table.Cell>
		  
		  <Table.Cell>{row.title}</Table.Cell>
		  
		  <Table.Cell>{row.title}</Table.Cell>
		  
          <Table.Cell>{row.description}</Table.Cell>
		  
          <Link to='/SLOBiHClanovi/update'>
			<Table.Cell> 
			<Button onClick={() => setData(row)}>Update</Button>
			</Table.Cell>
		  </Link>
		  
		  <Table.Cell>
		  <Button onClick={() => onDelete(row.id)}>Delete</Button>
	      </Table.Cell>
        </Table.Row>
   )})}
</Table.Body>
            </Table>
        </div>
		</div>
    )
}